module.exports = {"iconList":[8593289,8593300,8593301,8593291,8593385,8593397,8593398,8593401,8593410,8593411,8593412,8593414,8593415,8593416,8593417]}


//////////////////
// WEBPACK FOOTER
// ./src/_override/catalog/listingPage/json/iconProductsList.json
// module id = 137
// module chunks = 34 35